import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-179383cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "selector margin-right",
  style: {"z-index":"1"}
}
const _hoisted_2 = { class: "page-table-body-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "sp-control"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "station-selector" }
const _hoisted_6 = {
  key: 0,
  class: "reports-menu-root"
}
const _hoisted_7 = { class: "calendar-controller" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = {
  key: 0,
  class: "selected-date"
}
const _hoisted_10 = { class: "page-table-body page-reports-body" }
const _hoisted_11 = { class: "flex justify-center" }
const _hoisted_12 = { class: "flex flex-wrap justify-start" }
const _hoisted_13 = ["href", "onClick"]
const _hoisted_14 = { class: "camera-title" }
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = ["src", "onerror"]
const _hoisted_17 = ["href", "onClick"]
const _hoisted_18 = {
  key: 0,
  class: "camera-title",
  style: {"color":"white"}
}
const _hoisted_19 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_20 = ["src", "onerror"]
const _hoisted_21 = {
  key: 2,
  class: "camera-title",
  style: {"color":"white"}
}
const _hoisted_22 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_23 = ["src", "onerror"]

import { onMounted, watch, computed, ref } from 'vue'
import $ from 'jquery'
import { chain } from 'lodash'
import moment, { Moment } from 'moment'
import { useRoute, useRouter } from 'vue-router'
import ControllPanel from '@/components/common/CameraControllPanel.vue'
import CameraUdcSelect from '@/components/common/CameraUdcSelect.vue'
import { Option } from '@/components/common/UdcSelect.vue'
import DatePicker from '@/components/common/CameraDatePicker.vue'
import { useInitDataStore } from '@/stores/initDataStore'
import { useGlobalStore } from '@/stores/globalStore'

type CameraImage = {
  path: string
  name: string
  id: string
  date: string
  noImage: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore()
const route = useRoute()
const router = useRouter()
const queryDate = route.query.date as string

const INTERVAL = 1000 * 60 // 1minute
const initDataStore = useInitDataStore()
const cameraImages = ref<CameraImage[]>([])
const date = ref<Date>(moment(queryDate || new Date()).toDate())
const spActiveMenu = ref<string>('index')

// SPメニュー
const SP_MENU_ITEMS = {
  index: '一覧',
  panel_one: '詳細',
  history_5: '5分',
  history_60: '1時間',
}

// 画面種類時にしようするモニター名
const TYPE_NAMES = {
  MONITOR: 'panel_list',
  PANEL_ONE: 'panel_one',
  PANEL_MULTIPLE: 'panel_multiple',
}

// 各セレクトの初期値
const DEFAULT_AREA_CODE = 'kawasaki-cam-2-01'
const DEFAULT_CAMERA_TYPE = TYPE_NAMES.MONITOR
const DEFAULT_MONITOR_TYPE = 'history_5'

const cameraStation = ref<string>(DEFAULT_AREA_CODE)
const cameraType = ref<string>(DEFAULT_CAMERA_TYPE)
const monitorType = ref<string>(DEFAULT_MONITOR_TYPE)
let isOpened = false

// モニターする種類
const MONITOR_TYPES = [
  { label: '5分毎表示', value: 'history_5' },
  { label: '1時間毎表示', value: 'history_60' },
]
// 画面種類による取得数の設定
const NUMBER_OF_ACQUISITIONS = {
  NOW: 1,
  HISTORY_5: 36,
  HISTORY_60: 36,
}

// 画面種類による取得の間隔
const NUMBER_OF_INCREMENTS = {
  NOW: 5,
  HISTORY_5: 5,
  HISTORY_60: 60,
}

const isMonitor = computed(() => {
  return (
    !Object.keys(route.query).length || (Object.keys(route.query).length && route.query.type === TYPE_NAMES.MONITOR)
  )
})

const isDetail = computed(() => {
  return route.query.station && cameraType.value !== TYPE_NAMES.PANEL_MULTIPLE
})

const isMultiple = computed(() => {
  return route.query.station && cameraType.value === TYPE_NAMES.PANEL_MULTIPLE
})

const cameraStationSelected = computed(() => {
  return route.query.station
})

const cameraMoitorSelected = computed(() => {
  return route.query.monitor
})

const isMinute = computed(() => {
  return route.query.monitor && route.query.monitor === MONITOR_TYPES[0].value
})

const setCameraImages = () => {
  const time = get_target_time()
  const noImage = initDataStore.initData.layoutInfo.camera?.common.cameraNoimage

  let date: Moment

  let cameras = chain(initDataStore.initData)
    .get('cameraList', [])
    .filter(camera => camera.pastCamera)

  let get_count = 1
  let get_increment = 1
  if (!route.query.station) {
    cameraType.value = TYPE_NAMES.MONITOR
  } else {
    if (route.query.type) cameraType.value = route.query.type as string
    else cameraType.value = TYPE_NAMES.PANEL_ONE
  }

  // フィルタ設定
  if (!isMonitor.value) {
    // 局
    if (route.query.station) {
      cameras = cameras.filter(camera => camera.stationId === route.query.station)
      cameraStation.value = cameraStationSelected.value as string
    }
    // 日付
    if (route.query.date && moment(route.query.date as string, 'YYYY-MM-DD-HHmm').isValid()) {
      date = get_target_time(route.query.date as string)
    }
    // 種類
    if (route.query.monitor) {
      const monitor = route.query.monitor as string
      monitorType.value = cameraMoitorSelected.value as string
      if (monitor == MONITOR_TYPES[0].value) {
        monitorType.value = MONITOR_TYPES[0].value as string
      }
      if (cameraType.value === TYPE_NAMES.PANEL_MULTIPLE) {
        get_count = NUMBER_OF_ACQUISITIONS[monitor.toUpperCase() as keyof typeof NUMBER_OF_ACQUISITIONS]
        if (monitorType.value === DEFAULT_MONITOR_TYPE) {
          get_count = 36
        }
      }
      get_increment = NUMBER_OF_INCREMENTS[monitor.toUpperCase() as keyof typeof NUMBER_OF_INCREMENTS]
    }
  }

  const images: CameraImage[] = []
  // 画像を設定
  // 型に合わせてセット
  cameras
    .map(camera => {
      for (let i = 0; i < get_count; i++) {
        let label = camera.name
        let target_time = time
        let file_name = 'now'
        let image_date = ''

        if (!isMonitor.value) {
          // 日付があれば取得の開始対象を変更
          if (date) target_time = date
          target_time = moment(target_time).add(-get_increment * i, 'minute')
          image_date =
            target_time.format('YYYY') +
            '-' +
            target_time.format('MM') +
            '-' +
            target_time.format('DD') +
            '-' +
            target_time.format('HHmm')

          if (cameraType.value === TYPE_NAMES.PANEL_MULTIPLE) label = target_time.format('YYYY/MM/DD HH:mm')
          if (!moment(time).isSame(target_time)) {
            file_name =
              target_time.format('YYYY') +
              '/' +
              target_time.format('MM') +
              '/' +
              target_time.format('DD') +
              '/' +
              target_time.format('HHmm')
          }
        }
        let img_path = `/camera/${camera.stationId}/${file_name}.jpg`
        const image = new Image()
        image.src = img_path
        image.onerror = function () {
          $(`[src='${img_path}']`).attr('src', noImage)
        }

        images.push({
          path: img_path,
          name: label,
          id: camera.stationId,
          date: image_date,
          noImage: `this.onerror = null; this.src='${noImage}';`,
        })
      }
    })
    .value()

  cameraImages.value = images
}

// 基準とする時間を返す
function get_target_time(datetime = '') {
  var time = moment()
  if (datetime) {
    time = moment(datetime, 'YYYY-MM-DD-HHmm')
  }
  var minus_min = time.minutes() % 5
  return time.add(-minus_min, 'minute')
}

const cameraStations = computed(() => {
  return initDataStore.initData.cameraList
    ?.filter(camera => camera.pastCamera)
    .map(camera => {
      const label = camera.name
      return {
        label,
        value: camera.stationId,
      }
    }) as Option[]
})

function handleChangeCameraType(type?: string) {
  if (!type || type == TYPE_NAMES.MONITOR) {
    // トップを表示した時にセレクトの初期値にする
    cameraType.value = TYPE_NAMES.MONITOR
    cameraStation.value = DEFAULT_AREA_CODE
    monitorType.value = ''
    router.push(`/camera`)
  } else {
    $('.select-types').css('display', 'block')

    cameraType.value = type
    monitorType.value = DEFAULT_MONITOR_TYPE

    let add_type = `&type=${type}&monitor=${DEFAULT_MONITOR_TYPE}`

    if (route.query.date) {
      add_type = `&type=${type}&monitor=${DEFAULT_MONITOR_TYPE}&date=${route.query.date}`
    }
    router.push(`/camera?station=${cameraStation.value}${add_type}`)
  }
  setCameraImages()
}

// モニター種類の変更処理
const handleChangeMonitorType = (monitor: string) => {
  if (!route.query.station) {
    if (globalStore.isSP) {
      monitor = ''
    }
    router.push(`/camera`)
  } else {
    if (globalStore.isSP && monitor == '') {
      handleClickSpMenu(DEFAULT_MONITOR_TYPE)
    }

    let add_param = ''
    if (route.query.station) {
      add_param += `?station=${route.query.station}`
    }
    if (route.query.type) {
      add_param += `&type=${route.query.type}`
    }
    if (monitor) {
      add_param += `&monitor=${monitor}`
    }
    if (route.query.date) {
      add_param += `&date=${route.query.date}`
    }

    router.push(`/camera${add_param}`)
  }

  setCameraImages()
}

const handleChangeCameraStation = (station: string) => {
  let add_param = ''

  if (station) {
    add_param += `?station=${station}`
    if (route.query.type) add_param += `&type=${route.query.type}`
    else add_param += `&type=${TYPE_NAMES.PANEL_ONE}`
    if (route.query.monitor) add_param += `&monitor=${route.query.monitor}`
    if (route.query.date) add_param += `&date=${route.query.date}`
  } else cameraType.value = TYPE_NAMES.MONITOR

  router.push(`/camera${add_param}`)
  setCameraImages()
}

// カメラ種類
const cameraTypes = computed(() => {
  return initDataStore.initData.layoutInfo.camera?.common.cameraType.map(camera => {
    const label = camera.title
    return {
      label,
      value: camera.type,
    }
  }) as Option[]
})

// モニター種類
const monitorTypes = computed(() => {
  return MONITOR_TYPES
})

const handleChangeDate = (d: Date) => {
  const dateStr = moment(d).format('YYYY-MM-DD-HHmm')
  let add_param = ''

  if (route.query.station) {
    add_param += `?station=${route.query.station}`

    if (route.query.type) add_param += `&type=${route.query.type}`
    if (route.query.monitor) {
      add_param += `&monitor=${route.query.monitor}`
      monitorType.value = route.query.monitor as string
    }
    const time = get_target_time()
    if (dateStr && dateStr != time.format('YYYY-MM-DD-HHmm')) add_param += `&date=${dateStr}`

    router.push(`/camera${add_param}`)
  }

  setCameraImages()
}

const spMenuClass = (target: string) => {
  return target === spActiveMenu.value ? 'active' : ''
}

const handleClickSpMenu = (key: string) => {
  spActiveMenu.value = key

  if (key === 'index') {
    router.push('/camera')
  } else if (key === 'panel_one') {
    handleChangeCameraType(key)
  } else {
    const stationId = cameraStation.value
    const path = `/camera?station=${stationId}&type=panel_multiple&monitor=${key}`

    router.push(path)
  }
}

const setSpMenuActive = () => {
  const type = route.query.type as string
  const monitor = route.query.monitor as string

  if (!type) {
    return (spActiveMenu.value = 'index')
  }

  if (type === 'panel_one') {
    return (spActiveMenu.value = 'panel_one')
  } else {
    spActiveMenu.value = monitor
  }
}

watch(() => initDataStore.initData, setCameraImages, { immediate: true })
onMounted(() => {
  setInterval(setCameraImages, INTERVAL)
  setSpMenuActive()
})

// 表示地区の更新
watch(
  () => route.query.station,
  () => {
    setCameraImages()
  }
)

// 時間毎の更新
watch(
  () => route.query.monitor,
  () => {
    setCameraImages()
  }
)

// 日時の更新
watch(
  () => route.query.date,
  () => {
    setCameraImages()
  }
)

watch(
  () => cameraTypes,
  () => {
    setCameraImages()
  }
)

watch(
  () => route.query.type,
  () => {
    setCameraImages()
  }
)

watch(
  () => date.value,
  () => {
    const dateStr = moment(date.value).format('YYYY-MM-DD-HHmm')

    router.push({ query: { ...route.query, ...{ date: dateStr } } })
  }
)

$(document).on('click', function (e) {
  if (!isOpened && $(e.target).closest('.selected').length) {
    isOpened = true
    if ($(e.target).next().hasClass('options')) $(e.target).next().css('display', 'block')
  } else if (isOpened) {
    isOpened = false
    if ($('.selected').next().hasClass('options')) $('.selected').next().css('display', 'none')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page page-cameras page-table", [_unref(route).query.station ? '' : 'hide-calendar']])
  }, [
    (!_unref(globalStore).isSP)
      ? (_openBlock(), _createBlock(ControllPanel, {
          key: 0,
          onChangeDate: handleChangeDate,
          modelValue: date.value,
          "default-date": date.value,
          "show-resolution": false,
          "default-resolution": _unref(isMinute) ? 'minute' : 'hour'
        }, {
          left: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(CameraUdcSelect, {
                modelValue: cameraType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cameraType).value = $event)),
                onChange: handleChangeCameraType,
                options: _unref(cameraTypes),
                class: "select-types"
              }, null, 8, ["modelValue", "options"]),
              _withDirectives(_createVNode(CameraUdcSelect, {
                modelValue: cameraStation.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cameraStation).value = $event)),
                onChange: handleChangeCameraStation,
                options: _unref(cameraStations),
                class: "select-types"
              }, null, 8, ["modelValue", "options"]), [
                [_vShow, !_unref(isMonitor)]
              ])
            ]),
            (_unref(cameraStationSelected))
              ? _withDirectives((_openBlock(), _createBlock(CameraUdcSelect, {
                  key: 0,
                  modelValue: monitorType.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((monitorType).value = $event)),
                  onChange: handleChangeMonitorType,
                  options: _unref(monitorTypes),
                  class: "select-types monitor-type"
                }, null, 8, ["modelValue", "options"])), [
                  [_vShow, !_unref(isMonitor)]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "default-date", "default-resolution"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_unref(globalStore).isSP)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("ul", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SP_MENU_ITEMS, (name, key) => {
                return _createElementVNode("li", {
                  onClick: ($event: any) => (handleClickSpMenu(key)),
                  key: key,
                  class: _normalizeClass(spMenuClass(key))
                }, _toDisplayString(name), 11, _hoisted_4)
              }), 64))
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createVNode(CameraUdcSelect, {
                modelValue: cameraStation.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cameraStation).value = $event)),
                options: _unref(cameraStations),
                onChange: handleChangeCameraStation
              }, null, 8, ["modelValue", "options"]),
              (_unref(isMultiple))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(DatePicker, {
                          modelValue: date.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((date).value = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, !_unref(isMonitor)]
            ]),
            (_unref(isMultiple))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_unref(moment)(date.value).format('YYYY年MM月DD日')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cameraImages.value, (camera, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["p-1 m-1 camera-box", [_unref(isDetail) ? 'single' : 'content']])
              }, [
                (_unref(isMonitor))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: `/#/camera?station=${camera.id}&type=panel_one&monitor=${DEFAULT_MONITOR_TYPE}`,
                      onClick: ($event: any) => (
                  handleClickSpMenu('panel_one'),
                    handleChangeCameraStation(camera.id),
                    handleChangeMonitorType(DEFAULT_MONITOR_TYPE)
                )
                    }, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(camera.name), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: camera.path,
                          onerror: camera.noImage
                        }, null, 8, _hoisted_16)
                      ])
                    ], 8, _hoisted_13))
                  : _createCommentVNode("", true),
                (!_unref(isMonitor) && _unref(isMultiple))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: `/#/camera?station=${camera.id}&type=panel_one&monitor=${DEFAULT_MONITOR_TYPE}&date=${camera.date}`,
                      onClick: ($event: any) => (
                  handleClickSpMenu('panel_one'),
                    handleChangeCameraStation(camera.id),
                    handleChangeMonitorType(DEFAULT_MONITOR_TYPE)
                )
                    }, [
                      (!_unref(isMonitor))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(camera.name), 1))
                        : _createCommentVNode("", true),
                      (!_unref(isMonitor))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("img", {
                              src: camera.path,
                              onerror: camera.noImage
                            }, null, 8, _hoisted_20)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_17))
                  : _createCommentVNode("", true),
                (!_unref(isMonitor) && !_unref(isMultiple))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(camera.name), 1))
                  : _createCommentVNode("", true),
                (!_unref(isMonitor) && !_unref(isMultiple))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("img", {
                        src: camera.path,
                        onerror: camera.noImage
                      }, null, 8, _hoisted_23)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}
}

})